<template>
  <div class="youth-scene">
    <!-- <div class="youth-scene__bg-pattern"> -->
      <!-- logotype -->
      <div class="youth-scene__logotype">
        <SvgSymbol use="#youth-logotype"/>
      </div>

      <!-- scenario -->
      <div class="youth-scene__scenario">
        <div class="youth-scene__portrait">
          <SvgSymbol use="#youth-portrait"/>
        </div>
      </div>
    <!-- </div> -->

    <!-- scroll -->
    <div class="youth-scene__scroll" title="往下捲動" @click="onScrollClick">
      <div class="youth-scene__scroll-label">SCROLL</div>
      <div class="youth-scene__scroll-dot"></div>
      <div class="youth-scene__scroll-dot"></div>
      <div class="youth-scene__scroll-dot"></div>
      <div class="youth-scene__scroll-dot"></div>
      <div class="youth-scene__scroll-dot"></div>
      <div class="youth-scene__scroll-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YouthScene',
  methods: {
    onScrollClick (event) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Click',
        'eventAction': 'Click',
        'eventLabel': `Scroll-to-topics`
      })
      this.$scrollTo('#articles', 500, { offset: -30 })
    }
  }
}
</script>

<style lang="scss">
.youth-scene {
  @include use-layer(&);
  position: relative;
  width: 100%;
  min-height: 100vh;
  background:
    url(~@/assets/arrow-bottom-bg-red.png) repeat-x bottom left,
    url(~@/assets/line-background.png) repeat top center,
    #a0d1c6 url(~@/assets/background-pattern.png) repeat top left;
  overflow: hidden;

  &__logotype {
    display: block;
    position: absolute;
    bottom: 60%;
    left: 50%;
    width: 75%;
    transform: translateX(-50%);
    @include use-fixed-ratio(631, 316);
    @include rwd($RWD_IPHONE_678) {
      bottom: 65%;
    }
    @include rwd($RWD_TABLET_SMALL) {
      width: 500px;
    }
    @include rwd($RWD_TABLET) {
      bottom: 55%;
      width: 630px;
    }
    @include rwd($RWD_DESKTOP) {
      width: 530px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 53%;
      max-width: 700px;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__scenario {
    position: absolute;
    top: 45%;
    left: 0;
    width: 100%;
    height: 250px;
    margin-top: 0;
    @include rwd($RWD_IPHONE_678) {
      top: 40%;
    }
    @include rwd($RWD_TABLET_SMALL) {
      top: 50%;
    }
    @include rwd($RWD_TABLET) {
    }
    @include rwd($RWD_DESKTOP) {
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }
  }

  // &__scenario {
  //   position: relative;
  //   height: 250px;
  //   margin-top: 30px;
  //   overflow: visible;
  //   @include rwd($RWD_TABLET_SMALL) {
  //     height: 350px;
  //     margin-top: 50px;
  //   }
  //   @include rwd($RWD_TABLET) {
  //   }
  //   @include rwd($RWD_DESKTOP) {
  //     margin-top: 45px;
  //   }
  //   @include rwd($RWD_DESKTOP_WIDE) {
  //     margin-top: 40px;
  //   }
  // }

  &__portrait {
    position: relative;
    left: 50%;
    width: 200%;
    transform: translateX(-47%);
    @include use-fixed-ratio(1202, 682);
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 1000px;
    }
    @include rwd($RWD_TABLET) {
    }
    @include rwd($RWD_DESKTOP) {
      max-width: 860px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 72.72%;
      max-width: 1000px;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__scroll {
    position: absolute;
    left: 50%;
    bottom: 13%;
    width: 60px;
    margin-left: -30px;
    color: white;
    text-align: center;
    background: transparent;
    user-select: none;
    cursor: pointer;
    @include rwd($RWD_TABLET_SMALL) {
      bottom: 10%;
    }
    @include rwd($RWD_TABLET) {}
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {}

    &:active {
      transform: translateY(2px);
    }

    &-label {
      font-size: 0.875em;
    }

    &-dot {
      width: 2px;
      height: 2px;
      margin: 4px auto 0 auto;
      background: white;
      border-radius: 50%;

      & + & + & + & {
        display: none;

        @include rwd($RWD_IPHONE_678) {
          display: block;
        }
      }
    }

    &-arrow {
      width: 0;
      height: 0;
      margin: 8px auto 0 auto;
      border: 6px solid transparent;
      border-bottom: none;
      border-top: 7px solid white;
    }
  }
}

.mobile {
  // .youth-scene {
  //   min-height: 100vh;
  // }
}

.narrow-desktop { // Inject by App.vue when viewport size 960&up + 768&down
  .youth-scene {
    &__logotype {
      bottom: 60%;
      max-width: 350px;
    }

    &__scenario {
      top: 45%;
    }

    &__portrait {
      max-width: 700px;
    }

    &__scroll {
      bottom: 5%;
    }
  }
}
</style>
